"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validators = _interopRequireDefault(require("./validators"));

var _helpers = require("./helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var confirmation = (0, _helpers.memoize)(function (_ref) {
  var field = _ref.field,
      fieldLabel = _ref.fieldLabel,
      caseSensitive = _ref.caseSensitive,
      message = _ref.message,
      msg = _ref.msg,
      ifCond = _ref["if"],
      unless = _ref.unless;
  msg = msg || message;
  var fieldKeys = field.split('.');
  fieldLabel = fieldLabel || fieldKeys[fieldKeys.length - 1];
  return (0, _helpers.prepare)(ifCond, unless, false, function (value, allValues) {
    var fieldValue = '' + ((0, _helpers.getIn)(allValues, fieldKeys) || '');
    var cs = caseSensitive != null ? caseSensitive : _validators["default"].defaultOptions.caseSensitive;

    if (cs ? value !== fieldValue : value.toLowerCase() !== fieldValue.toLowerCase()) {
      return _validators["default"].formatMessage((0, _helpers.prepareMsg)(msg, 'confirmation', {
        fieldLabel: fieldLabel
      }));
    }
  });
});
var _default = confirmation;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-validators/lib/confirmation.js
// module id = 2567
// module chunks = 0